<template>
  <div class="digital-turnover-ratio-page">
    <div class="chart-block">
      <!-- <img src="/static/images/digitalarea/kqzzl.png" class="titl"> -->
      <div class="chart-box">
        <!-- <div class="tab-switch">
          <span v-for="item in tabData" :class="[{'current': tabKey==item}]" v-text="item" @click="tabSwitch(item)"></span>
        </div> -->
        <v-chart :options="options_zzl" />
      </div>
    </div>
  </div>
</template>

<script>
import echarts from 'echarts/lib/echarts'
export default{
  data() {
    let tabData = ['日', '周', '月'];
    return {
      tabData: tabData,
      tabKey: tabData[0],
      zzlList: [],
      options_zzl: {},
    }
  },
  mounted() {
    //定义全局方法
    window.gbfc_resetData = this.resetData;
    //初始化
    this.$initPage(this);
  },
  methods: {
    resetData() {
      //库区周转率
      this.getZzlList();
    },
    tabSwitch(item) {
      console.log(item)
      this.tabKey = item;
      this.getZzlList();
    },
    getZzlList() {
      let self = this;

      let url = '/api/DataStatistical/Day_Inv_ToRto';

      this.$handleRequest(window.ApiHost1+url, {
        "WareHouseCode": window.PYKWareHouseCode,
        //"ShelfNo": this.shelfNo,
      }, 'post', function(res) {  //success

        self.zzlList = res.retData.Rows ? res.retData.Rows : res.retData;
        self.setOptionsZzl();
      }, function(res) {  //fail
        console.log('--fail--', res)
      });
    },
    setOptionsZzl() {
      let self = this;
      let colors = this.$charts.colors.style_8;
      let chartsConf = this.$charts[window.CurrentTheme];
      let xdata = [];
      let sdata = [];
      let ldata = [];

      //单个
      if(typeof(this.zzlList.length) == 'undefined') {
        let dataStyle = {
          normal: {
            label: {show:false},
            labelLine: {show:false}
          }
        };
        this.zzlList.Ratio = Math.floor(this.zzlList.Ratio * 100) / 100;
        this.options_zzl = {
          //label: '今日周转率',
          title: {
            text: this.zzlList.Ratio+'%',
            x: 'center',
            y: 'center',
            itemGap: 20,
            textStyle : {
              color : colors[0],
              fontSize : 36,
              fontWeight : 'bolder'
            }
          },
          series : [
            {
              type: 'pie',
              clockWise: true,
              radius : [84, 90],
              itemStyle : dataStyle,
              data:[
                {
                  value: 100,
                  itemStyle : {
                    normal:{
                      color: chartsConf.series.color_1,
                    }
                  }
                }
              ]
            },
            {
              type: 'pie',
              clockWise: true,
              radius : [71, 90],
              itemStyle : dataStyle,
              data:[
                {
                  value: this.zzlList.Ratio,
                  itemStyle: {
                    normal:{
                      //颜色渐变函数 前四个参数分别表示四个位置依次为左、下、右、上
                      color: new echarts.graphic.LinearGradient(1, 0, 0, 0, [
                        {offset: 0, color: colors[0]}, {offset: 1, color: colors[1]}
                      ]),
                    }
                  }
                },
                {
                  value: 100-this.zzlList.Ratio,
                  name:'invisible',
                  itemStyle : {
                    normal : {
                      color: 'rgba(0,0,0,0)',
                      label: {show:false},
                      labelLine: {show:false}
                    },
                    emphasis : {
                      color: 'rgba(0,0,0,0)'
                    }
                  }
                }
              ]
            },
          ]
        };
        return;
      }

      //列表
      this.zzlList.forEach( function(l, li) {
        let xlabel = l.Date || l.ShelfNo || l.ShelfGridRegionNo;
        if(self.viewKey == '货位') {
          if(xlabel == '1') {
            xlabel = '前排';
          } else if(xlabel == '2') {
            xlabel = '中间';
          } else if(xlabel == '3') {
            xlabel = '后排';
          }
        }
        xdata.push(xlabel);
        ldata.push(Math.round(l.Ratio*100)/100);
      });
      let xrotate = 0;
      let xfontSize = 20;
      let xname = '';
      if(1 || this.viewKey == '库区') {
        xrotate = -40;
        xfontSize = 10;
      } else {
        xname = this.viewKey;
      }
      let tmp = {
        type:'line',
        color: colors[0],
        markPoint: {
          data: [
            {type: 'max', name: '最大值'},
            {type: 'min', name: '最小值'}
          ]
        },
        areaStyle: {},
        symbol: 'circle',
        symbolSize: 15,
        data: ldata
      };
      sdata.push(tmp);

      this.options_zzl = {
        tooltip: {
          trigger: 'axis',
          axisPointer : {
            type : 'line'
          }
        },
        xAxis: {
          type: 'category',
          name: xname,
          boundaryGap: false,
          nameTextStyle: {
            color: chartsConf.xAxis.color,
            fontSize: 18
          },
          axisLabel: {
            color: chartsConf.xAxis.color,
            fontSize: xfontSize,
            rotate: xrotate,
            interval: 0,
            margin: 16,
          },
          //设置轴线的属性
          axisLine:{
            lineStyle: {
              color: chartsConf.xAxis.color_1,
              width: 1, //这里是为了突出显示加上的
            }
          },
          data: xdata
        },
        yAxis : [
          {
            type : 'value',
            axisLabel: {
              color: chartsConf.yAxis.color,
              fontSize: 20,
              interval: 'auto',
              formatter: '{value}%'
            },
            //设置轴线的属性
            axisLine:{
              lineStyle: {
                color: chartsConf.yAxis.color_1,
                width: 1, //这里是为了突出显示加上的
              }
            },
            splitLine: {
              show: true,
              lineStyle: {
                color: [chartsConf.yAxis.color_2],
                width: 1,
                type: 'solid'
              }
            },
          }
        ],
        series: sdata
      };
    },
  }
}
</script>



// WEBPACK FOOTER //
// src/components/xiayan/digitalarea/TurnoverRatio.vue